import React, { Component } from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import { firebase } from "../models/firestore";
import "./CustomNavbar.css";

export default class CustomNavbar extends Component {
  render() {
    return (
      <Navbar default collapseOnSelect>
        <Navbar.Header>
          <Navbar.Brand>
            <Link to="/">Algemene Hulpdienst Heemskerk 2.3</Link>
          </Navbar.Brand>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav pullRight>
            <NavItem>
              <Link to="/" style={{ color: 'inherit', textDecoration: 'none' }}>
                Home
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/klanten" style={{ color: 'inherit', textDecoration: 'none' }}>
                Nw. opdracht
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/vrijwilligers" style={{ color: 'inherit', textDecoration: 'none' }}>
                Vrijwilligers
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/opdrachten" style={{ color: 'inherit', textDecoration: 'none' }}>
                Best. opdrachten
              </Link>
            </NavItem>
            <NavItem>
              <Link to="/overzichten" style={{ color: 'inherit', textDecoration: 'none' }}>
                Overzichten
              </Link>
            </NavItem>
            <Navbar.Text>
              <a 
                href="#" 
                onClick={(e) => {
                  e.preventDefault();
                  firebase.auth().signOut();
                }}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Uitloggen: {this.props.gebruikersNaam}
              </a>
            </Navbar.Text>
            {/* <NavItem eventKey={3} componentClass={Link} href="/news" to="/news">
              News
            </NavItem> */}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CustomNavbar.jsx